import React, { useState, useEffect, useContext } from 'react';
import { DefaultContext } from '../../../context/context_default';

const CardPreview = ({ card, mousePosition, visible }) => {
	const { tipos, subTipos, raridades } = useContext(DefaultContext);
	const [imageLoaded, setImageLoaded] = useState(false);
	const [imageError, setImageError] = useState(false);

	useEffect(() => {
		if (card?.url_img) {
			setImageLoaded(false);
			setImageError(false);

			const img = new Image();
			img.onload = () => setImageLoaded(true);
			img.onerror = () => setImageError(true);
			img.src = card.url_img;
		}
	}, [card?.url_img]);

	if (!visible || !card) return null;

	// Função para buscar nomes dos tipos por ID
	const getTipoNomes = (tipoIds) => {
		if (!tipoIds || !tipos) return '';
		const ids = Array.isArray(tipoIds) ? tipoIds : [tipoIds];
		return ids.map(id => {
			const tipo = tipos.find(t => t.id === id);
			return tipo ? tipo.nome : id;
		}).join(', ');
	};

	// Função para buscar nomes dos subtipos por ID
	const getSubTipoNomes = (subTipoIds) => {
		if (!subTipoIds || !subTipos) return '';
		const ids = Array.isArray(subTipoIds) ? subTipoIds : [subTipoIds];
		return ids.map(id => {
			const subTipo = subTipos.find(st => st.id === id);
			return subTipo ? subTipo.nome : id;
		}).join(', ');
	};

	// Função para buscar nome da raridade por ID
	const getRaridadeNome = (raridadeId) => {
		if (!raridadeId || !raridades) return raridadeId;
		const raridade = raridades.find(r => r.id === raridadeId);
		return raridade ? raridade.nome : raridadeId;
	};

	const getPreviewPosition = () => {
		if (!mousePosition) return { left: 0, top: 0 };

		const { x, y } = mousePosition;
		const previewWidth = 280;
		const previewHeight = 400;
		const margin = 20;

		// Ajustar posição para não sair da tela
		let left = x + margin;
		let top = y - previewHeight / 2;

		// Se sair da direita da tela, mostrar à esquerda do mouse
		if (left + previewWidth > window.innerWidth) {
			left = x - previewWidth - margin;
		}

		// Se sair do topo da tela
		if (top < margin) {
			top = margin;
		}

		// Se sair da parte inferior da tela
		if (top + previewHeight > window.innerHeight) {
			top = window.innerHeight - previewHeight - margin;
		}

		return { left, top };
	};

	const position = getPreviewPosition();

	return (
		<div
			className="fixed z-50 pointer-events-none transition-opacity duration-200"
			style={{
				left: `${position.left}px`,
				top: `${position.top}px`,
				opacity: visible ? 1 : 0,
				position: 'fixed',
				width: 'auto',
				height: 'auto',
				overflow: 'visible'
			}}
		>
			<div className="bg-slate-900 border-2 border-slate-600 rounded-lg shadow-2xl overflow-hidden">
				{/* Imagem da carta */}
				<div className="relative w-70 h-96">
					{imageLoaded && !imageError ? (
						<img
							src={card.url_img}
							alt={card.nome}
							className="w-full h-full object-cover"
						/>
					) : imageError ? (
						<div className="w-full h-full bg-slate-800 flex items-center justify-center">
							<div className="text-slate-400 text-center p-4">
								<div className="text-2xl mb-2">🖼️</div>
								<div className="text-sm">Imagem não encontrada</div>
							</div>
						</div>
					) : (
						<div className="w-full h-full bg-slate-800 flex items-center justify-center">
							<div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
						</div>
					)}
				</div>

				{/* Informações da carta */}
				<div className="p-3 bg-slate-800">
					<h3 className="text-white font-semibold text-sm truncate">{card.nome}</h3>

					{/* Custo e Raridade */}
					{/* <div className="flex justify-between items-center mt-1">
						{card.custo !== undefined && (
							<span className="text-blue-400 text-xs font-medium">
								Custo: {card.custo}
							</span>
						)}
						{card.raridade && (
							<span className="text-yellow-400 text-xs">
								{getRaridadeNome(card.raridade)}
							</span>
						)}
					</div> */}

					{/* Tipo */}
					{/* {card.tipo && (
						<div className="text-slate-300 text-xs mt-1">
							<span className="text-slate-400">Tipo:</span> {getTipoNomes(card.tipo)}
						</div>
					)} */}

					{/* Subtipo */}
					{/* {card.subTipo && (
						<div className="text-slate-300 text-xs mt-1">
							<span className="text-slate-400">Subtipo:</span> {getSubTipoNomes(card.subTipo)}
						</div>
					)} */}

					{/* Ataque e Vida
          {(card.ataque !== undefined || card.vida !== undefined) && (
            <div className="flex justify-between items-center mt-1">
              {card.ataque !== undefined && (
                <span className="text-red-400 text-xs font-medium">
                  ATK: {card.ataque}
                </span>
              )}
              {card.vida !== undefined && (
                <span className="text-green-400 text-xs font-medium">
                  HP: {card.vida}
                </span>
              )}
            </div>
          )} */}
				</div>
			</div>
		</div>
	);
};

export default CardPreview;